import {FC, useEffect, useRef, useState} from 'react';
import {useIntersectionObserver} from 'usehooks-ts';

export type IntersectionLoadableProps = {
    rootMargin?: string;
    keepRendered?: boolean;
    threshold?: number;
};

export const IntersectionLoadable: FC<IntersectionLoadableProps> = ({children, rootMargin, keepRendered, threshold}) => {
    const [wasRendered, setRendered] = useState<boolean>(false);
    const ref = useRef(null);
    const entry = useIntersectionObserver(ref, {threshold, rootMargin});

    useEffect(() => {
        if (!wasRendered && entry?.isIntersecting) {
            setRendered(true);
        }
    }, [entry?.isIntersecting, wasRendered]);

    const render = entry?.isIntersecting || (keepRendered && wasRendered);

    return <div ref={ref}>{render && children}</div>;
};
